var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.542 9.72805C16.3103 9.72805 16.1226 9.91679 16.1226 10.1497V13.8934C16.1218 14.5915 15.5591 15.1574 14.8645 15.1582H3.09777C2.40321 15.1574 1.84051 14.5915 1.83969 13.8934V2.90633C1.84051 2.20802 2.40321 1.64229 3.09777 1.64146H6.82121C7.05284 1.64146 7.24057 1.45272 7.24057 1.21984C7.24057 0.98696 7.05284 0.798218 6.82121 0.798218H3.09777C1.94027 0.799535 1.00229 1.74259 1.00098 2.90633V13.8934C1.00229 15.0571 1.94027 16.0002 3.09777 16.0015H14.8645C16.022 16.0002 16.96 15.0571 16.9613 13.8934V10.1498C16.9613 9.91695 16.7736 9.72805 16.542 9.72805Z",
    fill: "#747085",
    stroke: "#747085",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55762 7.50827L13.6807 1.35193L15.6555 3.33734L9.53237 9.49368L7.55762 7.50827Z",
    fill: "#747085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55957 10.4994L8.74187 9.89165L7.16404 8.3053L6.55957 10.4994Z",
    fill: "#747085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2023 0.309164C15.7926 -0.101753 15.1293 -0.101753 14.7197 0.309164L14.2749 0.756315L16.2497 2.74173L16.6944 2.29458C17.1033 1.88267 17.1033 1.21582 16.6944 0.803912L16.2023 0.309164Z",
    fill: "#747085"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c2c4b4054ce09bfef2aa092b091c11e5.svg";
export { ForwardRef as ReactComponent };